/**
 * Xonder payment account id is stored on company as `stripe_id` (backend field name).
 * Setup is complete when that value is present.
 */
export function getCompanyXonderAccountId(user: unknown): string | null {
  const company = (user as { company?: { stripe_id?: unknown; xonder_id?: unknown } } | null)
    ?.company;
  if (!company || typeof company !== "object") return null;

  const raw = company.stripe_id ?? company.xonder_id;
  if (raw == null || raw === "") return null;
  const id = String(raw).trim();
  return id.length > 0 ? id : null;
}

export function hasXonderPaymentSetup(user: unknown): boolean {
  return getCompanyXonderAccountId(user) != null;
}
